// This file is generated by the openedx/frontend-platform's "intl-import.js" script.
//
// Refer to the i18n documents in https://docs.openedx.org/en/latest/developers/references/i18n.html to update
// the file and use the Micro-frontend i18n pattern in new repositories.
//

import messagesOfAfZaLanguage from './af_ZA.json';
import messagesOfArLanguage from './ar.json';
import messagesOfAzLanguage from './az.json';
import messagesOfDaLanguage from './da.json';
import messagesOfDeLanguage from './de.json';
import messagesOfDeDeLanguage from './de_DE.json';
import messagesOfElLanguage from './el.json';
import messagesOfEs419Language from './es_419.json';
import messagesOfEsEsLanguage from './es_ES.json';
import messagesOfFaLanguage from './fa.json';
import messagesOfFrCaLanguage from './fr_CA.json';
import messagesOfHeLanguage from './he.json';
import messagesOfHiLanguage from './hi.json';
import messagesOfHuLanguage from './hu.json';
import messagesOfIdLanguage from './id.json';
import messagesOfItItLanguage from './it_IT.json';
import messagesOfJaLanguage from './ja.json';
import messagesOfLvLanguage from './lv.json';
import messagesOfPtBrLanguage from './pt_BR.json';
import messagesOfPtPtLanguage from './pt_PT.json';
import messagesOfRoLanguage from './ro.json';
import messagesOfRuLanguage from './ru.json';
import messagesOfSvLanguage from './sv.json';
import messagesOfSwLanguage from './sw.json';
import messagesOfTeLanguage from './te.json';
import messagesOfThLanguage from './th.json';
import messagesOfTrTrLanguage from './tr_TR.json';
import messagesOfUkLanguage from './uk.json';
import messagesOfUzLanguage from './uz.json';
import messagesOfViLanguage from './vi.json';
import messagesOfZhCnLanguage from './zh_CN.json';
import messagesOfZhHkLanguage from './zh_HK.json';

export default {
  'af-za': messagesOfAfZaLanguage,
  'zh-hk': messagesOfZhHkLanguage,
  'zh-cn': messagesOfZhCnLanguage,
  'vi': messagesOfViLanguage,
  'uz': messagesOfUzLanguage,
  'uk': messagesOfUkLanguage,
  'tr-tr': messagesOfTrTrLanguage,
  'th': messagesOfThLanguage,
  'te': messagesOfTeLanguage,
  'sw': messagesOfSwLanguage,
  'sv': messagesOfSvLanguage,
  'ru': messagesOfRuLanguage,
  'ro': messagesOfRoLanguage,
  'pt-pt': messagesOfPtPtLanguage,
  'pt-br': messagesOfPtBrLanguage,
  'lv': messagesOfLvLanguage,
  'ja': messagesOfJaLanguage,
  'it-it': messagesOfItItLanguage,
  'id': messagesOfIdLanguage,
  'hu': messagesOfHuLanguage,
  'hi': messagesOfHiLanguage,
  'he': messagesOfHeLanguage,
  'fr-ca': messagesOfFrCaLanguage,
  'fa': messagesOfFaLanguage,
  'es-es': messagesOfEsEsLanguage,
  'es-419': messagesOfEs419Language,
  'el': messagesOfElLanguage,
  'de-de': messagesOfDeDeLanguage,
  'de': messagesOfDeLanguage,
  'da': messagesOfDaLanguage,
  'az': messagesOfAzLanguage,
  'ar': messagesOfArLanguage,
};
